'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.function.name')
exports.__esModule = true
exports.default = void 0
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'))

var _is = require('../is')
var _Adapter = _interopRequireDefault(require('./Adapter'))
var _AdapterWithEvents = _interopRequireDefault(require('./AdapterWithEvents'))

var isSt = function isSt(st) {
  return st instanceof _Adapter.default || st instanceof _AdapterWithEvents.default
}
var StoragesCollection = /*#__PURE__*/ (function() {
  function StoragesCollection() {
    ;(0, _defineProperty2.default)(this, 'storages', {})
  }
  var _proto = StoragesCollection.prototype
  _proto.register = function register(arg) {
    var name = arg.name,
      type = arg.type,
      withEvents = arg.withEvents

    if (isSt(this.storages[name])) {
      return this.storages[name]
    }

    var args = { name: name, type: type }
    var newInstance = withEvents ? new _AdapterWithEvents.default(args) : new _Adapter.default(args)
    this.storages[name] = newInstance
    return newInstance
  }
  _proto.unregister = function unregister(name) {
    if (!isSt(this.storages[name])) return

    if ((0, _is.isF)(this.storages[name].destroy)) {
      this.storages[name].destroy()
    }

    delete this.storages[name]
  }
  _proto.get = function get(name) {
    if (isSt(this.storages[name])) {
      return {
        isRegistered: true,
        storage: this.storages[name]
      }
    }

    return { isRegistered: false }
  }
  return StoragesCollection
})()
exports.default = StoragesCollection



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Storages/StoragesCollection.js
// module id = 617
// module chunks = 0